import api from "./api.service";
import { adminTokenService } from "./admin.token.service";

export interface AdminZipcodeDispatchZone {
    id: number;
    iso2Country?: string;
    isO2Country?: string;
    zipcode: string;
    status: number; // 0: Inactive, 1: Active, 2: Deleted
    city?: string;
    state?: string;
}

export interface GetZipcodeDispatchZonesParams {
    page?: number;
    pageSize?: number;
    status?: number;
    SearchString?: string;
}

export interface GetZipcodeDispatchZonesResponse {
    statusCode: number;
    message: string;
    data: AdminZipcodeDispatchZone[];
    pagination: {
        totalCount: number;
        page: number;
        pageSize: number;
        totalPages: number;
    };
}

export interface CreateZipcodeDispatchZoneData {
    iso2Country: string;
    zipcode: string;
    status: number;
}

export interface UpdateZipcodeDispatchZoneData {
    id: number;
    iso2Country: string;
    zipcode: string;
    status: number;
}

export interface UpdateZipcodeDispatchZoneStatusData {
    id: number;
    status: number;
}

export interface DeleteZipcodeDispatchZoneData {
    id: number;
}

class AdminZipcodeDispatchZoneService {
    private getHeaders() {
        const token = adminTokenService.getAdminToken();
        return {
            Authorization: `${token}`,
        };
    }

    async getZipcodeDispatchZones(params?: GetZipcodeDispatchZonesParams): Promise<GetZipcodeDispatchZonesResponse> {
        try {
            const response = await api.get<GetZipcodeDispatchZonesResponse>(
                "/admin/get-zipcode-dispatch-zones",
                {
                    params,
                    headers: this.getHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching admin zipcode dispatch zones:", error);
            throw error;
        }
    }

    async getZipcodeDispatchZoneById(id: number): Promise<{ statusCode: number; message: string; data: AdminZipcodeDispatchZone }> {
        try {
            const response = await api.get<{ statusCode: number; message: string; data: AdminZipcodeDispatchZone }>(
                `/admin/get-zipcode-dispatch-zone/${id}`,
                {
                    headers: this.getHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            console.error(`Error fetching admin zipcode dispatch zone ${id}:`, error);
            throw error;
        }
    }

    async createZipcodeDispatchZone(data: CreateZipcodeDispatchZoneData): Promise<any> {
        try {
            const response = await api.post(
                "/admin/create-zipcode-dispatch-zone",
                {
                    ISO2Country: data.iso2Country,
                    Zipcode: data.zipcode,
                    Status: data.status
                },
                {
                    headers: this.getHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error creating admin zipcode dispatch zone:", error);
            throw error;
        }
    }

    async updateZipcodeDispatchZone(data: UpdateZipcodeDispatchZoneData): Promise<any> {
        try {
            const response = await api.post(
                "/admin/update-zipcode-dispatch-zone",
                {
                    id: data.id,
                    ISO2Country: data.iso2Country,
                    Zipcode: data.zipcode,
                    Status: data.status
                },
                {
                    headers: this.getHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error updating admin zipcode dispatch zone:", error);
            throw error;
        }
    }

    async changeZipcodeDispatchZoneStatus(data: UpdateZipcodeDispatchZoneStatusData): Promise<any> {
        try {
            const response = await api.post(
                "/admin/change-zipcode-dispatch-zone-status",
                {
                    id: data.id,
                    Status: data.status
                },
                {
                    headers: this.getHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error changing admin zipcode dispatch zone status:", error);
            throw error;
        }
    }

    async deleteZipcodeDispatchZone(data: DeleteZipcodeDispatchZoneData): Promise<any> {
        try {
            const response = await api.post(
                "/admin/delete-zipcode-dispatch-zone",
                {
                    id: data.id
                },
                {
                    headers: this.getHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error deleting admin zipcode dispatch zone:", error);
            throw error;
        }
    }
}

export const adminZipcodeDispatchZoneService = new AdminZipcodeDispatchZoneService();
